import { MIN_SITE_SCALE, MAX_SITE_SCALE } from './constants';
export function getValidZoomPercentage(requestedZoomPrecentage: number) {
  const newZoomPercentage = Math.min(
    Math.max(requestedZoomPrecentage | 0, MIN_SITE_SCALE * 100),
    MAX_SITE_SCALE * 100,
  );
  return newZoomPercentage;
}

export function getDecreasedZoomPercentageBy10(zoomPrecentage: number) {
  const newZoomPercentage =
    zoomPrecentage % 10 === 0
      ? zoomPrecentage - 10
      : ((zoomPrecentage / 10) | 0) * 10;
  return newZoomPercentage;
}

export function getIncreaseZoomPercentageBy10(zoomPrecentage: number) {
  const newZoomPercentage = (((zoomPrecentage + 10) / 10) | 0) * 10;
  return newZoomPercentage;
}
